<template>
    <div class="headline-options" :class="{'disabled' : historyMode}">
      <div class="headline-options__item">
        <div class="form-group" :class="{'disabled' : pageId == 0 || blocked}">
          <label>Komunikacja I (Headline)</label>
          <input class="form-control form-control-lg" type="text" v-model="headlineI" @input="save()"/>
        </div>
      </div>
      <div class="headline-options__item">
        <div class="form-group" :class="{'disabled' : pageId == 0 || blocked}">
          <label>Komunikacja II (np. do modułu, paska)</label>
          <input class="form-control form-control-lg" type="text" v-model="headlineII"  @input="save()"/>
        </div>
      </div>
    </div>
</template>

<script>

import debounce from "lodash.debounce";

export default {

    name: 'headlines',
    props:{

        orderId:{
            type: Number,
            default: 0
        },

        pageId:{
            type: Number,
            default: 0
        },

        pages:{
            type: Array,
            default: () => [],
        },

        historyMode:{
            type: Boolean,
            default: false,
        },

        blocked:{
            type: Boolean,
            default: false,
        },

    },
    data(){

        return{

            headlineI: '',
            headlineII: '',

        }

    },
    watch:{

        pageId: function(){
            this.getHeadlines();
        }

    },
    methods:{

        getHeadlines(){

            this.headlineI = '';
            this.headlineII = '';

            let page = this.pages.find(page => page.id === this.pageId);
      
            if(page){

                if(page.firstCommunication){
                    this.headlineI = page.firstCommunication
                }

                if(page.secondCommunication){
                    this.headlineII = page.secondCommunication
                }

            }

        },

        addHeadlines(){

            if(this.pageId == 0 || this.historyMode){
                return;
            }

            let headlines ={
                firstCommunication: this.headlineI ? this.headlineI : '',
                secondCommunication: this.headlineII ? this.headlineII : '',
            }

            const token = localStorage.getItem('auth_token');

            this.$http.put(`order-pages/${this.pageId}`, headlines, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                this.$parent.getOrder();
              
            })
            .catch(error =>{

            })

        },

        save: debounce(function(){

            this.addHeadlines();

        }, 500),

    },

}
</script>

<style lang="scss" scoped>

.headline-options{
  display:flex;

  &__item{
    width:50%;

    & .form-group{
      width:60%;

      &.disabled{
          pointer-events: none;
      }
    }
  }
}

</style>
